export enum CarTyres {
  WINTER = 'WINTER',
  SUMMER = 'SUMMER',
  ALL_SEASON = 'ALL_SEASON',
}
